import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '外部项目用户场景',
    type: 'BDSUMMARY_1',
}
